var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"noDataParty"},[_c('div',{staticClass:"imgbox"},[(_vm.showpic)?_c('img',{attrs:{"src":_vm.NoImg,"alt":"no data","srcset":""}}):_vm._e()]),_c('div',{staticClass:"desc"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.desc)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }